export const environment = {
  production: true,
  proxyUrl: 'https://lea.lgccda.proxy.eveasoft.com',
  date: '', // Permet de voir quelle version est déployée (à remplacer lors du déploiement)
  version: '3.6.4',
};



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/environments/environment.ts